import { createAction } from '@reduxjs/toolkit';

import type { HearingInfoResponse } from 'features/call/call-base/interfaces';

export const hearingInfoReceived = createAction<HearingInfoResponse>(
  'call/hearingInfoReceived'
);
